import { fromJS } from 'immutable'
import { SET_AUTH_DATA } from '../auth/actions'
import { BOOTSTRAP_PHASE_COMPLETE } from '../app/index'
import { SET_APP_BOOTSTRAP_PHASE } from '../app/actions'
import {
  getPaytrackDataLastTransaction,
} from './actions'

function getLastTransactionOnAuth (store, action) {
  const auth = fromJS(action.payload.data)
  if (auth.get('jwt')) {
    store.dispatch(getPaytrackDataLastTransaction({ auth }))
  }
}

function getLastTransactionOnAppBootComplete (store, action) {
  const { auth, paytrack } = store.getState()
  const { payload = {} } = action
  const { phase } = payload
  const authToken = auth.get('jwt')
  const paytrackProcessing = paytrack.get('processing')
  const lastTransaction = paytrack.get('lastTransaction')
  // get lastTransaction from paytrack if we are logged in
  // and paytrack is not processing and we have no paytrack data
  if (
    authToken
    && phase === BOOTSTRAP_PHASE_COMPLETE
    && !paytrackProcessing
    && !lastTransaction
  ) {
    store.dispatch(getPaytrackDataLastTransaction({ auth }))
  }
}

/**
 * Redux middleware
 * @param {import('redux').Store} store A redux store
 * @returns {import('redux').Middleware} Redux middleware
 */
export default function middleware (store) {
  return (next) => (action) => {
    switch (action.type) {
      case SET_AUTH_DATA:
        getLastTransactionOnAuth(store, action)
        break
      case SET_APP_BOOTSTRAP_PHASE:
        getLastTransactionOnAppBootComplete(store, action)
        break
      default:
        break
    }
    next(action)
  }
}
